<div class="col-12">
  <form class="login-form">
    <div class="title mb-0">
      <span class="text">Intergrip</span>
    </div>

    <div class="subtitle">
      <span class="text">{{ 'auth.2fa.' + method + '.login.subtitle' | translate }}</span>
    </div>

    <div class="mb-4 mx-auto mx-md-0">
      <app-input-code [formControl]="inputCodeControl" (valuesFilled)="onSubmit()"></app-input-code>
    </div>

    <div class="mb-4 mx-auto mx-md-0">
        <a href="https://intercom.help/intergrip-bv/nl/articles/9789800-hoe-kan-ik-tweestapsverificatie-resetten"
           class="login-link"
           target="_blank"
           rel="noopener noreferrer"
           data-test="forgot-2fa-link">
            Tweestapsverificatie herstellen
        </a>
    </div>

    <div class="login-actions">
      <cap-button [label]="'auth.sign-in.button' | translate"
                  [disabled]="inputCodeControl?.invalid || isSubmitting"
                  [class.disabled]="inputCodeControl?.invalid || isSubmitting"
                  [icon]="isSubmitting ? submittingIcon : null"
                  type="button"
                  styleClass="primary"
                  [attr.data-test]="'login-button'"
                  (click)="onSubmit()">
      </cap-button>

      <span class="login-separator">{{ 'auth.sign-in.or-label' | translate }}</span>

      <a routerLink="/auth/login"
         class="login-link"
         data-test="forgot-password-link">
        {{ 'auth.2fa.button.back-main-page' | translate }}
      </a>
    </div>
  </form>
</div>
